import { theme } from 'component-library/utils';

export const resolveThemeColor = (key: string) => {
  const themeColors = theme.colors as Record<string, string>;
  // eslint-disable-next-line security/detect-object-injection
  return themeColors[key] as string;
};
